document.addEventListener('DOMContentLoaded', () => {
  const isCartPage = window.location.href.includes('/cart');

  if (isCartPage) {
    setTimeout(() => {
      BSS_B2B.observer.cartSubject.listenCartCheckout();
    }, 3000);

    const targetNode = document.querySelector('#kaching-cart');

    if (targetNode) {
      const observer = new MutationObserver((mutationsList) => {
        // console.log(MutationList)
        for (const mutation of mutationsList) {
          if (
            mutation.type === 'attributes' &&
            mutation.attributeName === 'class'
          ) {
            BSS_B2B.observer.cartSubject.listenCartCheckout();
          }
        }
      });

      observer.observe(targetNode, {
        attributes: true,
        attributeFilter: ['class'],
      });
    } else {
      console.warn('<cart-form> không tìm thấy trong DOM');
    }
  }
});

document.addEventListener('DOMContentLoaded', function () {
  if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
    const checkBtnInterval = setInterval(() => {
      const btn = document.getElementById("kaching-cart__checkout-button");
      if (btn) {
	      clearInterval(checkBtnInterval);
        const newBtn = btn.cloneNode(true);
        newBtn.setAttribute("type", "button");
        btn.parentNode.replaceChild(newBtn, btn);

        // new event
        newBtn.addEventListener("click", function(e) {
          e.preventDefault();
          console.log("Checkout clicked");
          BSS_B2B.observer.cartSubject.notifyObserver('CartCheckout', 'ClickCheckout');
        });
      }
    }, 500);
  }
});

if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    updateCartPrices();
  }, 3000);

  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      // console.log(MutationList)
      for (let mutation of MutationList) {
        if (mutation.target.classList.contains("kaching-cart__module") 
          || mutation.target.classList.contains("kaching-cart__checkout-button-label")) {
            setTimeout(() => {
              updateCartPrices();
            }, 2500);
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);

  function updateCartPrices() {
    if (
      !BSS_B2B?.storage?.cartStorage?.store ||
      BSS_B2B.storage.cartStorage.store.size === 0
    ) {
      console.warn("Cart storage is empty or unavailable.");
      return;
    }

    const cartMap = new Map();

    BSS_B2B.storage.cartStorage.store.forEach((value) => {
      cartMap.set(String(value.variant_id), value.key);
    });

    document.querySelectorAll(".kaching-cart-item").forEach((item) => {
      const productLink = item.querySelector(".kaching-cart-item__title");
      const priceElement = item.querySelector(".kaching-cart-item__price-info");

      let variantId = null;

      if (productLink) {
        try {
          const url = new URL(productLink.href, window.location.origin);
          variantId = url.searchParams.get("variant");
        } catch (error) {
          console.warn("Invalid product URL:", productLink.href);
        }
      }

      if (variantId && priceElement) {
        const cartKey = cartMap.get(String(variantId));

        if (cartKey) {
          if (!priceElement.hasAttribute("bss-b2b-cart-item-key")) {
            priceElement.setAttribute("bss-b2b-cart-item-key", cartKey);
          }

          if (!priceElement.hasAttribute("bss-b2b-final-line-price")) {
            priceElement.setAttribute("bss-b2b-final-line-price", "");
          }
        }
      }
    });

    const subtotalElement = document.querySelector(".kaching-cart__checkout-button-label .priceRange");

    if (
      subtotalElement &&
      !subtotalElement.hasAttribute("bss-b2b-cart-total-price")
    ) {
      subtotalElement.setAttribute("bss-b2b-cart-total-price", "");
    }

    BSS_B2B.observer.cartSubject.notifyObserver("CartMutate", "CartPriceMutate");
  }  
}


